module.exports = __webpack_public_path__ + "static/media/icon_delete-form.cbd29cc8.svg";